import React from 'react';

interface AssetDetailSectionProps {
    title: string;
    subtitle?: string;
    children: React.ReactNode;
    defaultCollapsed?: boolean;
    className?: string;
}

const AssetDetailSection: React.FC<AssetDetailSectionProps> = ({
    title,
    subtitle,
    children,
    defaultCollapsed = false,
    className = '',
}) => {
    const [collapsed, setCollapsed] = React.useState(defaultCollapsed);

    return (
        <section className={`bg-text-contrast rounded-[5px] shadow-sm px-5 py-4 ${className}`}>
            <button
                type={'button'}
                onClick={() => setCollapsed(!collapsed)}
                className={'w-full flex items-center justify-between text-left'}
            >
                <div>
                    <h2 className={'text-lg font-semibold text-foreground'}>{title}</h2>
                    {subtitle && (
                        <p className={'text-sm text-foreground/60 mt-0.5'}>{subtitle}</p>
                    )}
                </div>
                <svg
                    className={`w-5 h-5 text-foreground/40 transition-transform ${collapsed ? '' : 'rotate-180'}`}
                    fill={'none'}
                    viewBox={'0 0 24 24'}
                    stroke={'currentColor'}
                    strokeWidth={2}
                >
                    <path strokeLinecap={'round'} strokeLinejoin={'round'} d={'M19 9l-7 7-7-7'} />
                </svg>
            </button>
            {!collapsed && (
                <div className={'mt-4'}>
                    {children}
                </div>
            )}
        </section>
    );
};

export default AssetDetailSection;
